<template>
    <q-table
        :title="title"
        :data="data"
        :columns="columns"
        :pagination.sync="paginationAux"
        :hide-pagination="hidePagination"
        :rows-per-page-options="[10, 20, 50, 100]"
        :loading="loading"
        binary-state-sort
        row-key="id"
        flat
        @request="request"
    >
        <template v-slot:top>
            <slot name="top" />
        </template>
        <template v-slot:body-cell-trainers="props">
            <q-td key="trainers" :props="props">
                <div
                    v-for="(trainer, index) in props.row.lessonTrainers"
                    :key="index"
                >
                    <div class="trainer-name">
                        {{ `${trainer.trainers.user.first_name}` }}
                        <q-badge
                            :color="trainerBadgeColor(trainer.trainerRoles.id)"
                        >
                            {{
                                getTranslationFromJSONString(
                                    trainer.trainerRoles.title,
                                    locale.key
                                )
                            }}
                        </q-badge>
                    </div>
                </div>
            </q-td>
        </template>
        <template v-slot:body-cell-glossary="props">
            <q-td key="glossary" :props="props">
                {{ props.row.course.glossary }}
            </q-td>
        </template>
        <template v-slot:body-cell-start_date="props">
            <q-td key="start_date" :props="props">
                {{ formatDate(props.row.start_date) }}
            </q-td>
        </template>
        <template v-slot:body-cell-end_date="props">
            <q-td key="end_date" :props="props">
                {{ formatDate(props.row.end_date) }}
            </q-td>
        </template>
    </q-table>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import formatDate from '@/helpers/date-time'
import store from '@/store'

export default {
    name: 'LessonsTableComponent',

    mixins: [translate],

    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: null,
        },
        filter: {
            type: Object,
            default: () => {},
        },
        columns: {
            type: Array,
            default: () => [],
        },
        data: {
            type: Array,
            default: () => [],
        },
        pagination: {
            type: Object,
            default: () => {},
        },
        hidePagination: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            paginationAux: {},
            filterAux: {},
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        },
    },

    watch: {
        pagination(value) {
            this.paginationAux = value
        },

        filter(value) {
            this.filterAux = value
        },
    },

    mounted() {
        this.paginationAux = this.pagination
        this.filterAux = this.filter
    },

    methods: {
        trainerBadgeColor(roleId) {
            return roleId === 1 ? 'dark' : 'secondary'
        },

        request(props) {
            const { page, rowsPerPage, sortBy, descending } = props.pagination
            const filter = props.filter

            this.paginationAux.page = page
            this.paginationAux.rowsPerPage = rowsPerPage
            this.paginationAux.sortBy = sortBy
            this.paginationAux.descending = descending

            this.filterAux = filter

            this.$emit('request', this.paginationAux, this.filterAux)
        },

        formatDate(value) {
            return value
                ? formatDate.fromServerToUxString(value, 'fullTime')
                : null
        },
    },
}
</script>
